import { useEffect } from "react";

/**
 * Lightweight per-page SEO helper.
 * Updates document.title and meta description/og:title/og:description on mount.
 */
export default function useSeo({ title, description, path = "" }) {
  useEffect(() => {
    if (title) {
      document.title = `${title} · ENCES Global`;
    }
    const set = (selector, attr, value) => {
      if (!value) return;
      const el = document.head.querySelector(selector);
      if (el) el.setAttribute(attr, value);
    };
    set('meta[name="description"]', "content", description);
    set('meta[property="og:title"]', "content", title ? `${title} · ENCES Global` : "ENCES Global");
    set('meta[property="og:description"]', "content", description);
    set('meta[name="twitter:title"]', "content", title ? `${title} · ENCES Global` : "ENCES Global");
    set('meta[name="twitter:description"]', "content", description);
    if (path) {
      const canonical = document.head.querySelector('link[rel="canonical"]');
      if (canonical) canonical.setAttribute("href", `https://encesglobal.com${path}`);
      set('meta[property="og:url"]', "content", `https://encesglobal.com${path}`);
    }
  }, [title, description, path]);
}
